import { render, staticRenderFns } from "./AddProducer.vue?vue&type=template&id=59cb1e46&scoped=true&"
import script from "./AddProducer.vue?vue&type=script&lang=js&"
export * from "./AddProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cb1e46",
  null
  
)

export default component.exports